// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__MOv_J g-grid-container","post":"style_post__iRLCv","relatedPosts":"style_relatedPosts__qucD_"};